import Swiper from 'swiper';
import { isBeforeOrEqualDevice } from './config';

require('owl.carousel');

const initializeSliders = () => {
  /*
   * Home Slider
   */
  $('.Slider .owl-carousel').owlCarousel({
    items: 1,
    margin: 0,
    loop: true,
    nav: true,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 4000,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    dots: false,
  });

  /*
   * News Slider
   */
  const newsSlider = $('.BlockNews__block .owl-carousel');
  if (newsSlider) {
    newsSlider.owlCarousel({
      items: 2,
      margin: 44,
      loop: true,
      nav: true,
      navText: [
        "<div class='nav-btn prev-slide'></div>",
        "<div class='nav-btn next-slide'></div>",
      ],
      dots: false,
      responsive: {
        0: {
          items: 1,
          margin: 27,
          autoplay: false,
          loop: false,
        },
        1025: {
          items: 3,
          margin: 44,
          loop: false,
          autoplay: false,
        },
        1367: {
          items: 2,
          margin: 44,
          loop: false,
          autoplay: false,
        },
      },
    });

    newsSlider.on('change.owl.carousel', (event) => {
      const { value } = event.property;
      if (value === 1) {
        if (!isBeforeOrEqualDevice('md')) {
          $('.BlockNews__block-left').addClass('BlockNews__block-hide');
        }
      } else if (value < 2) {
        if (!isBeforeOrEqualDevice('md')) {
          $('.BlockNews__block-left').removeClass('BlockNews__block-hide');
        }
      }
    });
  }

  $('.Production__slider .owl-carousel').owlCarousel({
    items: 3,
    margin: 33,
    nav: true,
    loop: false,
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    dots: false,
    responsive: {
      0: {
        items: 1,
        margin: 27,
      },
      992: {
        items: 2,
        margin: 44,
        autoplay: false,
      },
      1367: {
        loop: false,
      },
    },
  });

  /*
   * Small Sliders
   */
  $('.js-slider .owl-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    dots: false,
    autoHeight: false,
  });

  /*
   * History slider
   */
  $('.BlockHistory__blockSlider-slider .owl-carousel').owlCarousel({
    items: 1,
    margin: 15,
    nav: true,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    dots: false,
    autoHeight: true,
    responsive: {
      0: {
        items: 1,
        margin: 5,
        autoplay: false,
        loop: false,
      },
      992: {
        autoplay: false,
        loop: false,
      },
    },
  });

  $('.BlockHistory__image .owl-carousel').owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    autoHeight: true,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    dots: false,
  });
};

export default initializeSliders;
